import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  breadcrumbTransferOrders: {
    id: 'BNkdyY',
    defaultMessage: 'Transfer Orders',
    description: 'Breadcrumb link to transfer orders list',
  },
  orderNumberHeader: {
    id: 'X9aZcn',
    defaultMessage: 'TO: #{orderId}',
    description: 'Header title for transfer order page',
  },
});
